<template>
    <c-modal
        v-model="modal"
        size="sm"
        centered
        :tag="false"
        title="Delete Menu Type Warning"
        confirm-label="Ok"
        cancel-label="Cancel"
        hide-footer
    >
        <template>
            <b-container fluid class="px-0">
                <b-row>
                    <b-col cols="12">
                        <div class="mb-3 w-100 text-center">
                            Please delete all items and categories on this menu before deleting the whole menu.
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <b-btn block variant="warning" @click="modal = false">
                            OK, Got it.
                        </b-btn>
                    </b-col>
                </b-row>
            </b-container>
        </template>
    </c-modal>
</template>

<script>
    import CModal from "../../../shared/Cmodal";
    export default {
        name: "warningDelete",
        props: {
            value: {
                required: true,
                type: Boolean,
                default: false
            },
            hasCategory:{
                type:Boolean,
                required:true
            }
        },
        components: {CModal},
        computed: {
            modal: {
                get () {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        }
    }
</script>

<style scoped>

</style>
